/**
 * Authentication route constants
 *
 * Centralized location for auth-related routes to ensure consistency
 * and easy maintenance across the application.
 */
export const AUTH_ROUTES = {
  SIGN_IN: '/auth/sign-in',
  SIGN_UP: '/auth/sign-up',
} as const;

/**
 * Helper function to check if a URL is an auth route
 */
export function isAuthRoute(url: string): boolean {
  return url === AUTH_ROUTES.SIGN_IN || url === AUTH_ROUTES.SIGN_UP;
}

/**
 * Helper function to check if a URL includes an auth route
 */
export function includesAuthRoute(url: string): boolean {
  return url.includes(AUTH_ROUTES.SIGN_IN) || url.includes(AUTH_ROUTES.SIGN_UP);
}
